import React from 'react';

import FieldWithApply from '../utility/FieldWithApply';
import ActivateLink from '../utility/ActivateLink';
import {hasTeamLeadPowers} from '../../models/Agent';

/*
 * Tax Exempt Widget - seen only by Agents (ordinary users get nothing),
 * if this is available it first presents as a "Tax Exempt?" text link.
 *
 * Once clicked, if the agent is a Team Lead it becomes an input field
 * with some instructions; if the agent is not a Team Lead it just becomes
 * instructions.
 */
export default function PONumberWidget({
  currentAgent, shoppingCart = {}, callbacks}) {

  const {customerPoNumber} = shoppingCart;

  const prompt = <span><span className="fa fa-file-spreadsheet" />{' '} PO Number?</span>;

  return <div className="relative text-sm text-white">
    <ActivateLink className="text-white" prompt={prompt} defaultOpen={!!customerPoNumber}>
      <div className="text-gray-700"><FieldWithApply
        shoppingCart={shoppingCart} callbacks={callbacks}
        name='customerPoNumber'
        defaultValue={customerPoNumber}
        placeholder="Customer PO Number"
      /></div>

    </ActivateLink>
  </div>
}
